import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./Audit.module.scss";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import Question from "./components/Question/Question";
// import HR from "components/HR/HR";
import Button from "components/Button/Button";
import Modal from "components/Modal/Modal";
import { loadAuditAction, updateAuditAction, loadUsersAction, completeAuditAction, verifyAuditAction } from "store/actions/Actions";

const Audit = props => {
    const [state, setState] = useState([
        {
            question: "",
            answer: "3",
            risk: "",
            notes: "",
            user_id: "",
            questions: []
        }
    ]);

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showDescription, setShowDescription] = useState(false);
    const [updated, setUpdated] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const auditID = props.location.search.split("id=")[1] || 1;

    const {
        UsersReducer,
        AuditReducer,
        loadUsersAction,
        loadAuditAction,
        completeAuditAction,
        updateAuditAction,
        verifyAuditAction
    } = props;

    // Load data
    useEffect(() => {
        if (!UsersReducer.users) {
            loadUsersAction();
        }
    }, [UsersReducer.users, loadUsersAction]);

    useEffect(() => {
        if (!AuditReducer.audit && UsersReducer.users) {
            loadAuditAction(auditID);
            verifyAuditAction(auditID);
        }
        if (AuditReducer.audit && UsersReducer.users) {
            setState(AuditReducer.audit);
            setCurrentQuestionIndex(AuditReducer.audit.current);
        }
    }, [AuditReducer.audit, UsersReducer.users, auditID, loadUsersAction, loadAuditAction, verifyAuditAction]);

    useEffect(() => {
        verifyAuditAction(auditID);
    }, [state.currentQuestionIndex, auditID, verifyAuditAction]);

    const setNewState = index => key => e => {
        const questions = [...state.questions];
        questions[index] = {
            ...state.questions[index],
            [key]: (e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || e.target.value
        };

        const {
            // questions: oldQuestions,
            ...rest
        } = state;

        setState({ ...rest, questions });
        setUpdated(true);
    };

    const changeQuestion = direction => {
        window.scrollTo(0, 0);
        if (direction && currentQuestionIndex < state.questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else if (!direction) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const handleBack = () => {
        const { user_id, response_id, question_id, answer, notes, risk } = state.questions[currentQuestionIndex];
        window.scrollTo(0, 0);
        changeQuestion(0);
        if (updated) {
            if (!state.finalized) {
                updateAuditAction({ 
                    user_id: answer !== "4" ? '' : user_id,
                    response_id,
                    question_id,
                    answer: answer === "" ? "3" : answer,
                    notes,
                    risk,
                    audit: auditID,
                });
                window.setTimeout(() => {
                    verifyAuditAction(auditID);
                }, 1000);
            }
        }
        if (!updated) {
            setUpdated(true);
        }
    };

    const handleNext = () => {
        const { user_id, response_id, question_id, answer, notes, risk } = state.questions[currentQuestionIndex];
        window.scrollTo(0, 0);
        changeQuestion(1);
        if (updated) {
            if (!state.finalized) {
                updateAuditAction({ 
                    user_id: answer !== "4" ? '' : user_id,
                    response_id,
                    question_id,
                    answer: answer === "" ? "3" : answer,
                    notes,
                    risk,
                    audit: auditID,
                });
                window.setTimeout(() => {
                    verifyAuditAction(auditID);
                }, 1000);
            }
        }
        if (!updated) {
            setUpdated(true);
        }
    };

    const handleFinalizeOpen = () => {
        window.scrollTo({ top:0, behavior:"smooth" });
        setShowModal(true);
        return;
    }

    const handleClose = () => {
        props.history.push("/achieve/audits")
        return;
    }

    const isLast = (currentQuestionIndex === (state.questions && state.questions.length - 1) || 0);
    const isFirst = currentQuestionIndex === 0;
    const isFinalized = state.finalized;

    const isFinalizable = AuditReducer.finalizable || false;

    return (
        <AppLayoutWrapFull>
            {state.questions && <PageHeader
                className={`${styles["page-header"]} ${showDescription ? styles["show-description"] : ""}`}
            >
                <p className={styles.heading}>
                    {state.questions[currentQuestionIndex]["regulation_number"]}
                    <i
                        className={`fal fa-question-circle ${styles["heading-icon"]} ${showDescription ? styles["active"] : ""}`}
                        onClick={() => setShowDescription(!showDescription)}
                    />
                </p>
                <p>{showDescription && state.questions[currentQuestionIndex].description}</p>
            </PageHeader>}
            {state.questions &&
                <Container fluid>

                    <span className={styles.total}>
                        {currentQuestionIndex + 1} of {state.questions.length} questions
                    </span>

                    <Question
                        finalized={state.finalized || false}
                        users={UsersReducer.users}
                        question={state.questions[currentQuestionIndex]}
                        setData={setNewState(currentQuestionIndex)}
                    />

                    <div className={styles.buttons}>

                        <Button
                            style={{ marginLeft: 'auto' }}
                            text="BACK"
                            color="secondary"
                            icon="fal fa-long-arrow-left"
                            onClick={isFirst ? null : () => handleBack()}
                            disabled={isFirst ? true : false}
                        />

                        {isLast ?
                            <span style={{ marginLeft: '20px' }}>
                                {!isFinalized &&
                                <Button onClick={() => handleNext()} text={"SAVE"} />
                                }
                            </span>
                        :
                            <span style={{ marginLeft: '20px' }}>
                            <Button onClick={() => handleNext()} text={"CONTINUE"} iconEnd="fal fa-long-arrow-right" />
                            </span>
                        }

                        {!isFinalized &&
                            <Button
                                className={`${styles.finalize} ${isFinalized ? styles.finalized : ''}`}
                                color="danger"
                                onClick={isFinalizable ? handleFinalizeOpen : false}
                                disabled={isFinalizable ? false : true}
                                text="FINALIZE"
                            />
                        }

                        {isFinalized &&
                            <Button
                                className={styles.finalize}
                                color="danger"
                                onClick={handleClose}
                                text="CLOSE"
                            />
                        }

                    </div>

                </Container>
            }
            {showModal ? (

        <Modal
            className={styles["modal"]}
            setShowModal={setShowModal}
        >
            <div
                className={styles["modal-body"]}>
                <div>
                    <p className={styles["modal-heading"]}>Finalize Audit</p>
                </div>

                <div className={styles["modal-content"]}>
                    <div>
                        <p>Once you finalize the audit you can no longer change your answers.</p>
                        <br />
                        <b className={styles["confirmation-modal-warning"]}>This action cannot be undone</b>
                    </div>
                </div>
            </div>

            <div className={styles["modal-footer"]}>
                <Button
                    className={styles.button}
                    text="CANCEL"
                    color="secondary"
                    onClick={() => setShowModal(false)}
                />
                <Button
                    className={styles.button}
                    text="FINALIZE"
                    color="primary"
                    onClick={() => {
                        completeAuditAction({ auditID });
                        setShowModal(false);
                        props.history.push("/achieve/audits");
                    }}
                />
            </div>

        </Modal>) : ""}
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = state => ({
    UsersReducer: state.UsersReducer,
    AuditReducer: state.AuditReducer
});

const mapDispatchToProps = {
    loadAuditAction,
    completeAuditAction,
    loadUsersAction,
    updateAuditAction,
    verifyAuditAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Audit);
